import { liveElement } from '@the-shared/live-element';

export function viewElement< T extends HTMLElement >(
	selector: string,
	callback: ( element: T ) => void,
	rootMargin = '600px 0px 600px 0px',
	threshold = [ 0.01 ]
) {
	let intersectionObserverInit = false;

	const observer = new IntersectionObserver(
		( entries ) => {
			entries.forEach( ( entry ) => {
				if ( intersectionObserverInit || entry.isIntersecting ) {
					observer.unobserve( entry.target );
					callback( entry.target as T );
				} else {
					intersectionObserverInit = true;
				}
			} );
		},
		{
			rootMargin,
			threshold,
		}
	);

	liveElement< T >( selector, ( element ) => {
		observer.observe( element );
	} );
}
